import React, { FC } from "react";
import { IDamsList, IStateOfKnowledge, dataEntry, IDataTest, ISocietalRisk, ISummaryControlMeasureAdequacy, ISummaryControlMeasureAssessment, ICostSummary, ISummaryCriticalHazards, ISummarySOK, ILikelihood, IHarmSummary } from "../../types/types";
import { Accordion, AccordionSummary, Grid, Paper, Tooltip } from "@material-ui/core";
import BarChart from "./bar";
import DamHeatMap from "./dam_heat_map";
import { ExpandMore } from "@material-ui/icons";
import Typography from "@material-ui/core/Typography";
import Map from "./map";
import PieChart from "./pie";
import { trafficLight } from "../../theme";
import SoKInfo from "./sok_infobar";
import NoDamInfo from "./no_dam";
import HeatMapTable from "./heat_map_table";
import { makeStyles, withStyles } from '@material-ui/core/styles';



interface ICHProps {
    damList: IDamsList[],
    assessments_filtered: number[],
    likelihood: ILikelihood[],
    harm: IHarmSummary[],
}


const LikelihoodSummary: FC<ICHProps> = ({ likelihood, harm, damList, assessments_filtered }) => {

    const filtered_likelihood: Array<ILikelihood> = [];
    const filtered_harm: Array<IHarmSummary> = [];

    assessments_filtered.forEach(id => {
        const filtered = likelihood.filter(s => s.assessment_project_id === id)
        filtered.forEach(element => filtered_likelihood.push(element))
    })

    assessments_filtered.forEach(id => {
        const filtered = harm.filter(s => s.assessment_project_id === id)
        filtered.forEach(element => filtered_harm.push(element))
    })

    let anyDams = false
    if (filtered_likelihood.length > 0) {
        anyDams = true
    }
    // console.log(anyDams)


    // plot a pie chart of the likelihood for each dam
    const likelihood_pie = (): IDataTest<dataEntry> => {

        // superscript in utf8 \u207B -
        // superscript in utf8 \u00B3 3
        // superscript in utf8 \u2074 4
        // superscript in utf8 \u2075 5
        return {
            title: 'Likelihood',
            description: [''],
            data: [{ name: "AFP ≥ 10\u207B\u00B3", value: [filtered_likelihood.filter(l => l.max_annual_failure_probability >= 0.001).length] },
            { name: '10\u207B\u00B3 > AFP ≥ 10\u207B\u2074', value: [filtered_likelihood.filter(l => l.max_annual_failure_probability < 0.001 && l.max_annual_failure_probability >= 0.0001).length] },
            { name: '10\u207B\u2074 > AFP ≥ 10\u207B\u2075', value: [filtered_likelihood.filter(l => l.max_annual_failure_probability < 0.0001 && l.max_annual_failure_probability >= 0.00001).length] },
            { name: 'AFP < 10\u207B\u2075', value: [filtered_likelihood.filter(l => l.max_annual_failure_probability < 0.00001).length] },
            { name: 'Undefined', value: [filtered_likelihood.filter(l => l.max_annual_failure_probability < 0).length] }],
            colour: {
                background: [trafficLight.bred, trafficLight.byellow, trafficLight.bgreen, trafficLight.vgreen, trafficLight.grey],
                font: [trafficLight.red, trafficLight.yellow, trafficLight.green, trafficLight.green, trafficLight.dgrey]
            },
            height: 350,
            subtitle:'Annual Failure Probability'
        }
    }

    const harm_pie = (category: string): IDataTest<dataEntry> => {

        let data = filtered_harm.filter(h => h.name === category)

        let categories = [['Extreme', 'Extreme'], ['High A', 'High'], ['High B', 'High'], ['High C', 'High'], ['Significant', 'Significant'], ['Low', 'Low'], ['Very Low', 'Low']]

        //for each piece of data, check and find the worst category
        let data_worst_case = data.map(d => {

            let worst_case = "NaN"

            for (const element of categories) {
                if (d.category.includes(element[0])) {
                    worst_case = element[1]
                    break
                }
            }

            return worst_case
        })


        let title = category === 'Sunny Day Consequence Category' ? 'Harm - Sunny Day' : 'Harm - Flood'
        let subtitle = category === 'Sunny Day Consequence Category' ? 'Sunny Day Consequence Category' : 'Flood Consequence Category'


        return {
            title: title,
            description: [''],
            data: [
                { name: 'Low', value: [data_worst_case.filter(l => l === 'Low').length] },
                { name: 'Significant', value: [data_worst_case.filter(l => l === 'Significant').length] },
                { name: 'High', value: [data_worst_case.filter(l => l === 'High').length] },
                { name: 'Extreme', value: [data_worst_case.filter(l => l === 'Extreme').length] },
                { name: 'Not assessed', value: [data_worst_case.filter(l => l === 'NaN').length] }],
            colour: {
                background: [trafficLight.vgreen, trafficLight.bgreen, trafficLight.byellow, trafficLight.bred, trafficLight.grey],
                font: [trafficLight.green, trafficLight.green, trafficLight.yellow, trafficLight.red, trafficLight.dgrey]
            },
            height: 350,
            subtitle: subtitle,
            radius: '55%'
        }

    }

    return (

        <>
            <Accordion>
                <AccordionSummary id={"1"} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> Summary </Typography>
                </AccordionSummary>
                <Typography>
                <div style={{ padding: "10px" }}>
                <Paper variant={"outlined"} style={{ textAlign: 'left', height:'50px', display:'flex', alignItems:'center', padding:'10px' }}>

                        The pie charts shown below group dams by their critical failure mode that has the highest likelihood or harm.
                    
                    </Paper>
                    </div>
                    <Grid container spacing={3} xl={12} direction="row">
                        {(<>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                {anyDams
                                    ? <PieChart data={harm_pie('Sunny Day Consequence Category')} />
                                    : <NoDamInfo />}
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                {anyDams
                                    ? <PieChart data={harm_pie('Flood Consequence Category')} />
                                    : <NoDamInfo />}
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                {anyDams
                                    ? <PieChart data={likelihood_pie()} />
                                    : <NoDamInfo />}
                            </Grid>
                        </>)}

                    </Grid>
                </Typography>
            </Accordion>
        </>
    )

}


export default LikelihoodSummary;